module.exports = "<div class=\"loading\" *ngIf=\"show\">\r\n  <img  [src]=\"getImage()\" />\r\n</div>\r\n"